<template>
  <v-container grid-list-md>
    <h2 class="mt-3">Congratulations!</h2>    
    <p class="mt-2 mb-5" id="detail">
    You'll now hear important updates from us via email.</p>
    <router-link to="/">Go to home page</router-link>

  </v-container>
</template>

<script>
export default {
  name: "Confirmation",
  data: () => ({})
};
</script>

<style>
#detail{
  font-size: 16px;
}
</style>